import store  from './store'; // Adjust the import path as needed

const authHandler = {
    install(app) {
        app.config.globalProperties.$isLoggedIn = function () {
            return store.getters.isAuthenticated;
        };

        app.config.globalProperties.$isAdmin = function () {
            return store.getters.isAdmin;
        };

        app.config.globalProperties.$isTeacher = function () {
            return store.getters.isTeacher;
        };

        app.config.globalProperties.$isAssistant = function () {
            return store.getters.isAssistant;
        };

        app.config.globalProperties.$isDancer = function () {
            const role = store.getters.role;
            if (store.getters.isDancer) return true;
            if (role === 1) return true;
            return false;
        };

        app.config.globalProperties.$isParent = function () {
            const role = store.getters.role;
            if (store.getters.isParent) return true;
            if (role === 2) return true;
            return false;
        };

        app.config.globalProperties.$getRole = function () {
            return store.getters.role;
        }

        app.config.globalProperties.$getChildId = function () {
            return store.getters.childId;
        }

        app.config.globalProperties.$getUserId = function () {
            return store.getters.userId;
        }
        app.config.globalProperties.$logout = async function () {
            await store.dispatch('logout');
            this.$router.push('/login');
        };

        app.config.globalProperties.$login = async function () {
            try {
                const userData = await store.dispatch('login', {
                    email: this.email,
                    password: this.password,
                });
                this.$router.push('/');
                return userData;
            } catch (err) {
                this.error = err.message; // Handle error message
            }
        };
    },
};

export default authHandler;
